import FilledButton from "../../../component/FilledButton";

const AlertPost = ({ handlePin, handleOpenModal }) => {
    return (
        <div className="pin_a_post">
            <h2>Pin a post</h2>
            {
                <>
                    <p>You are about to PIN a post in the course discussion board. This action will unpin the previous pin and and add this post as a pinned post.</p>
                    <p>Do you want to proceed?</p>
                </>
            }
            <div className="action text_center mt_5">
                <FilledButton onClick={() => handleOpenModal()} value="no" />
                <FilledButton onClick={() => { handlePin(); handleOpenModal(); }} value="yes" className="btn btn_primary ml_3" />
            </div>
        </div>
    )
};

export default AlertPost